var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgViewImg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "300px",
    height: "170px",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1 0 0 1 -736 -376 )"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 736 376  L 1036 376  L 1036 546  L 736 546  L 736 376  ",
    fillRule: "nonzero",
    fill: "#cccccc",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 748 388  L 1024 388  L 1024 534  L 748 534  L 748 388  ",
    fillRule: "nonzero",
    fill: "#ffffff",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 904.75 427  C 897.61 427  892 421.39  892 414.25  C 892 407.11  897.61 401.5  904.75 401.5  C 911.89 401.5  917.5 407.11  917.5 414.25  C 917.5 421.39  911.89 427  904.75 427  ",
    fillRule: "nonzero",
    fill: "#cccccc",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 753 530  L 753 454.65  L 819.75 420.4  L 913.2 483.42  L 966.6 440.95  L 1020 483.42  L 1020 530  L 753 530  ",
    fillRule: "nonzero",
    fill: "#169bd5",
    stroke: "none"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgViewImg);
export default __webpack_public_path__ + "static/media/viewImg.20b883fad6ed6c43b6079f6f433a08b7.svg";
export { ForwardRef as ReactComponent };